export const SERVICE_GRID =
  "grid-cols-[48px_2.1fr_1.1fr_1.1fr_1.1fr_0.8fr_1.1fr_64px] gap-2";
